import { getPath, Path } from 'urlBuilder';

export const path = getPath(Path.customerFeedback);

export const feedbackPromotionStorageKey = 'drawerHiddenFeedbackPromotion';
